import * as React from 'react';
import { BaseButton } from './druid/BaseButton';
import { customizable, nullRender } from './druid/./druid/./druid/Utilities';
import { IButtonProps } from './druid/Button.types';
import { getStyles } from '/druid/ActionButton.styles';

/**
 * {@docCategory Button}
 */
@customizable('ActionButton', ['theme', 'styles'], true)
export class ActionButton extends React.Component<IButtonProps, {}> {
  public render(): JSX.Element {
    const { styles, theme } = this.props;

    return (
      <BaseButton
        {...this.props}
        variantClassName="ms-Button--action ms-Button--command"
        styles={getStyles(theme!, styles)}
        onRenderDescription={nullRender}
      />
    );
  }
}
